import { Fragment } from 'react';
import TemplateModal from './templateModal';
import { useTranslation } from 'react-i18next';

const InsufficientCreditsModal = ({ isVisible, onCancel, onConfirm }) => {
    const { t } = useTranslation(['confirmModal']);

    return (
        <TemplateModal
            title={t('title.insufficient-credits')}
            content={
                <Fragment>
                    <p style={{ margin: '0' }}>{t('message.not-enough-credits')}</p>
                    <p style={{ margin: '0' }}>{t('message.purchase-more-credits')}</p>
                </Fragment>
            }
            isVisible={isVisible}
            onCancel={onCancel}
            onConfirm={onConfirm}
            confirmText={t('buttons.yes')}
            cancelText={t('buttons.no')}
        />
    );
};

export default InsufficientCreditsModal;
